import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";

// AG Grid Enterprise License Key
export const AG_GRID_LICENSE_KEY = "Using_this_{AG_Grid}_Enterprise_key_{AG-094214}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{OPEN_Health_Communications_LLP.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{OpenHealth_iSLR}_only_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{OpenHealth_iSLR}_need_to_be_licensed___{OpenHealth_iSLR}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{27_September_2026}____[v3]_[01]_MTc5MDQ2MzYwMDAwMA==054fd72a067bbb87f9380199dcb3ab8b";

/**
 * Initialize AG Grid with proper module registration and license setup
 * Call this function in your component's onMount lifecycle
 */
export function initializeAgGrid(): void {
    // Register all community and enterprise modules
    ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule]);
    
    // Set the enterprise license key
    LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);
}

/**
 * Get the AG Grid license key (for reference)
 */
export function getAgGridLicenseKey(): string {
    return AG_GRID_LICENSE_KEY;
}
